import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { BaseService } from "../base.service";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class FiltersService extends BaseService {
  constructor(http: Http, cookieService: CookieService) {
    super(http, cookieService);
    this.init("filters");
  }

  getFilters(season, region, listId, country, appFilter = null) {
    let headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Authorization", this.getAuthToken());
    let item = {
      season: season,
      region: region,
      list_id: listId,
      country: country
    };
    if (appFilter) {
      item["filter"] = appFilter;
    }

    return this.http
      .post(this.baseURL(), JSON.stringify(item), { headers: headers })
      .toPromise()
      .then(response => {
        return response.json();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/products/filters.service.ts